/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
export default (() => {
  "use strict";

  /**
   * Other functions...
   */

  const init = () => {
    const input = document.getElementById("search-input");
    const searchBtn = document.getElementById("search-btn");

    const expand = () => {
      searchBtn.classList.toggle("close");
      input.classList.toggle("square");
    };

    searchBtn.addEventListener("click", expand);
  };

  return {
    init
  };
})();
